import { render, staticRenderFns } from "./CCPagination.vue?vue&type=template&id=5e536e9c&scoped=true"
import script from "./CCPagination.vue?vue&type=script&lang=js"
export * from "./CCPagination.vue?vue&type=script&lang=js"
import style0 from "./CCPagination.vue?vue&type=style&index=0&id=5e536e9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e536e9c",
  null
  
)

export default component.exports